"use strict";
import Vue from "vue";
import Layout from "@/components/layout/Layout.vue";
Vue.component("Layout", Layout);
